<template>
  <div class="campus-collect-container" :class="{'mini-collect-container': isWxMini}">
    <w-nav-bar nav_title="我的关注" v-if="!isWxMini" @mobileLeftBtn="pageBack"/>
    <skeleton-list :only-skeleton-list="true" :skeleton-number="8" v-if="loadingShow"></skeleton-list>
    <template v-else>
      <div class="scroll-container" v-if="offersListData.length">
        <cube-scroll :options="{ pullUpLoad: true }" @pulling-up="onPullingUp" :data="[ offersListData ]">
          <offers-list :offers-data="offersListData" @changeAttentionState="changeAttentionState"/>
          <w-more-loading v-if="page < pageCount" />
          <w-no-more v-if="page >= pageCount" />
        </cube-scroll>
      </div>
      <w-no-result v-else>
        <div slot="resultContent" class="result-content flex-column">
          <p class="title">暂无关注企业</p>
          <p class="sub-title">关注目标企业，招聘信息不错过</p>
          <button class="theme-button flex-center" @click="toCampusOfferIndex">去关注</button>
        </div>
      </w-no-result>
    </template>
    <attention-dialog :dialog-state="attentionState" @handleClose="changeAttentionState" @toCampusManage="toCampusManage" />
  </div>
</template>

<script>
  import WNavBar from '../../../../components/global/w-navbar'
  import OffersList from '../../components/job-list'
  import SkeletonList from '../../components/skeleton-list'
  import WNoResult from '../../../../components/global/w-no-result'
  import WNoMore from '../../../../components/global/w-no-more'
  import WMoreLoading from '../../../../components/global/w-more-loading'
  import WLoading from '../../../../components/global/w-loading'
  import {envMixin, loginMixin} from "../../../../assets/js/mixin/global";
  import {campusOfferMixin} from "../../../../assets/js/mixin/jobs";
  import {userMixin} from "../../../../assets/js/mixin/user";

  export default {
    name: 'campus-collect',
    mixins: [ envMixin, campusOfferMixin, loginMixin, userMixin ],
    data() {
      return {
        page: 0,
        pageCount: 1,
        offersListData: [],
        loadingShow: true
      }
    },
    beforeRouteEnter(to, from, next) {
      document.title = '我的收藏'
      next()
    },
    async mounted() {
      this.verifyLogged()
      await this.loginByWx()
      this.getUserAccountData()
      this.getFavoriteList()
    },
    computed: {},
    watch: {},
    components: {
      WNavBar,
      OffersList,
      WNoResult,
      WMoreLoading,
      WNoMore,
      WLoading,
      SkeletonList
    },
    methods: {
      pageBack() {
        this.$router.back()
      },
      // 点击跳转至列表页面
      toCampusOfferIndex() {
        if (this.isWxMini) {
          this.$wechat.miniProgram.switchTab({
            url: '/pages/campusOffersList/campusOffersList'
          })
        } else {
          this.$router.replace('/jobs/campus/offers')
        }
      },
      // 页面上拉加载
      onPullingUp() {
        if (this.page < this.pageCount) {
          // this.page += 1
          this.getFavoriteList()
        }
      },
      // 获取关注列表数据
      getFavoriteList() {
        this.$api.campusOffers.getCampusFavorites({
          page: this.page + 1,
          size: 10
          
        }).then(res => {
          if (res.code === 1000) {
            this.offersListData = this.page + 1 === 1 ? res.data.comp_recruit_infos : [ ...this.offersListData, ...res.data.comp_recruit_infos ]
            this.pageCount = res.data.page_count
            this.page += 1
          }
          this.loadingShow = false
        }).catch(e => {
          console.log(e)
          this.loadingShow = false
        })
      },
      // 获取用户数据
      getUserAccountData() {
        let keys = Object.keys(this.userData || {})
        if (keys && !keys.length) {
          this.getUserData()
        }
      },
      // 进入页面判断是否登录
      verifyLogged() {
        if (!this.alreadyLogged) {
          this.needLogin()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../assets/scss/global/variable";
  @import "../../../../assets/scss/global/mixin";
  @import "../../styles/no-result";
  .campus-collect-container {
    height: $screen-height;
    @include mobile-container(44px, 1px);
    .scroll-container {
      height: calc(calc(var(--vh, 1vh) * 100) - 44px - constant(1px + env(safe-area-inset-bottom)));
      height: calc(calc(var(--vh, 1vh) * 100) - 44px - calc(1px + env(safe-area-inset-bottom)));
    }
  }
  .mini-collect-container {
    padding-top: 0;
    .scroll-container {
      height: calc(calc(var(--vh, 1vh) * 100) - constant(1px + env(safe-area-inset-bottom)));
      height: calc(calc(var(--vh, 1vh) * 100) - calc(1px + env(safe-area-inset-bottom)));
    }
  }
</style>